import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import PayementRHService from "../../services/RHService/PayementRHService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import DataAvancesList from "./Salaires/Avances/DataAvancesList";
import withLoader from "../../components/layouts/WithLoader";

const PayementSalaires = ({ startLoading, stopLoading }) => {
  const animatedComponents = makeAnimated();
  const [userRole, setUserRole] = useState("");
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);
  const [yearSelected, setYearSelected] = useState(null);
  const [yearSelectedOption, setYearSelectedOption] = useState(null);
  const [allYears, setAllYears] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [monthPlaceholder, setMonthPlaceholder] = useState("Choisir...");
  const [monthsOptions, setMonthsOptions] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [finalMonth, setFinalMonth] = useState("");
  const [finalYear, setFinalYear] = useState("");

  const [yearSelectPlaceHolder, setYearSelectPlaceHolder] =
    useState("Choisir...");

  const [listTransactions, setListTransactions] = useState([]);

  const onAddAvanceHandler = () => {
    navigate(`/ajouterAvance`);
  };
  const onAddSalaireHandler = () => {
    navigate(`/ajouterSalaire`);
  };
  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }
  }, []);

  useEffect(() => {
    setAllYears([]);
    var currentYear = new Date().getFullYear();

    var lastyear = currentYear - 1;
    setAllYears((oldArray) => [
      ...oldArray,
      { value: lastyear, label: lastyear },
    ]);
    setAllYears((oldArray) => [
      ...oldArray,
      { value: currentYear, label: currentYear },
    ]);
    var newyear = currentYear + 1;
    setAllYears((oldArray) => [
      ...oldArray,
      { value: newyear, label: newyear },
    ]);
    setMonthsOptions([]);
    setMonthsOptions([
      { value: "01", label: "Janvier" },
      { value: "02", label: "Février" },
      { value: "03", label: "Mars" },
      { value: "04", label: "Avril" },
      { value: "05", label: "Mai" },
      { value: "06", label: "Juin" },
      { value: "07", label: "Juillet" },
      { value: "08", label: "Aout" },
      { value: "09", label: "Septembre" },
      { value: "10", label: "Octobre" },
      { value: "11", label: "Novembre" },
      { value: "12", label: "Decembre" },
    ]);
  }, []);
  const onChangeSelectedYear = (selectedOptionn) => {
    setSelectedOption();
    setYearSelected(selectedOptionn.value);
    setFinalYear(selectedOptionn.value);
    setYearSelectPlaceHolder(selectedOptionn.label);
  };
  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
    setFinalMonth(selectedOption.value);
    setMonthPlaceholder(selectedOption.label);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const listePayementsRH = (e) => {
    startLoading();
    PayementRHService.getListPayementEmployeBySociete(
      getCurrentUserId(),
      finalMonth,
      finalYear
    )
      .then((response) => {
        console.log(response);
        if (response.data["error"]) {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :  " + response.data["error"]);
        } else {
          setListTransactions(response?.data?.success);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :  " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              Salaires et avances
              {/* <div className="row">
                <div class="col-md-10"></div>
                <div class="col-md-1">
                  {userRole.includes("ADMIN") && (
                    <button
                      class="btn btn-dark  float-right"
                      onClick={onAddAvanceHandler}
                    >
                      {" "}
                      Payer Avance
                    </button>
                  )}
                </div>
                <div class="col-md-1">
                  {userRole.includes("ADMIN") && (
                    <button
                      class="btn btn-dark  float-right"
                      onClick={onAddSalaireHandler}
                    >
                      Payer Salaire
                    </button>
                  )}
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <div className="row">
                <div class="form-group col-sm-3">
                  <div>
                    <label>Choisir l'année </label>
                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={yearSelectedOption}
                      onChange={onChangeSelectedYear}
                      options={allYears}
                      placeholder={yearSelectPlaceHolder}
                    />
                  </div>
                </div>
                <div className="form-group col-sm-3">
                  <div>
                    <label>Choisir le mois</label>
                    <Select
                      value={selectedMonth}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      options={monthsOptions}
                      onChange={handleMonthChange}
                      defaultValue={selectedMonth}
                      placeholder={monthPlaceholder}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="col-12">
                <button
                  type="submit"
                  onClick={listePayementsRH}
                  className="btn btn-dark float-right"
                >
                  Confirmer
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {listTransactions && listTransactions.length !== 0 && (
        <section className="content-header">
          <div className="container-fluid">
            <DataAvancesList listTransaction={listTransactions} />
          </div>
        </section>
      )}

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>      
  );
};
export default withLoader(PayementSalaires);
